import { HelmetDexteel } from "@dexteel/mesf-core";
import { Box, Typography } from "@mui/material";
import { Rolls } from "./components/Rolls";

export const RollsPage = () => {
	return (
		<>
			<HelmetDexteel title="Rolls" />
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					height: "calc(100vh - 130px)",
					gap: 1,
					p: 1,
					bgcolor: "#f0f2f5",
				}}
			>
				<Typography variant="h5" sx={{ fontWeight: 600 }}>
					Rolls
				</Typography>
				<Rolls />
			</Box>
		</>
	);
};
